import { useDispatch, useSelector } from 'react-redux';
import { Button, TextField, withStyles } from '@material-ui/core';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import { updateTrackingExceptionByTno } from '../../../actions/utActions';
import { showAlertSnackbar } from '../../../reducers/uiSlice';
import { adminServerInstance } from '../../../axios/instances';

const FixedTextField = withStyles((theme) => ({
    root: {
        '& .MuiOutlinedInput-input': {
            padding: '10px !important',
        },
        width: 300,
        marginBottom: 20,
    },
}))(TextField);

function ExceptionUpdate(props) {
    const dispatch = useDispatch();
    const {t} = useTranslation('updateToolbox');

    const [orderException, setOrderException] = useState('');
    const [selectedFile, setSelectedFile] = useState(null);
    const [exception, setException] = useState(11007);
    const [exceptionList, setExceptionList] = useState([]);

    const exceptionListComplete = useSelector(state => state.editOrder.getExceptionDetails)

    const handleOrderException = (event) => {
        setOrderException(event.target.value);
    };
    const handleKeyPress = (event) => {
        if(event.key === 'Enter') {
            handleScanException();
        }
    }

    function handleScanException() {
        dispatch(updateTrackingExceptionByTno(orderException, exception))
        .then((res) => {
            if(res.invalidTno.length > 0) {
                dispatch(showAlertSnackbar({type: "warning", message: `Invalid TNO:${res.invalidTno[0]}`}));
            } else {
                dispatch(showAlertSnackbar({type: "success", message: t('update_successfully')}));
            }
            setOrderException('');
        })
        .catch(() => {
            dispatch(showAlertSnackbar({type: "error", message: t('update_failed')}));
        })
    }
    function handleScanExceptionBatch() {
        let formData = new FormData();
        formData.append("file", selectedFile);
        formData.append("exception", exception);

        adminServerInstance.post(
            `/business/updatetrackingexceptionbyfile`,
            formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            }
        )
        .then((res) => {
            if(res.data.data.invalidTno.length > 0) {
                dispatch(showAlertSnackbar({type: "warning", message: `Invalid TNO:${res.data.data.invalidTno}`}));
            } else {
                dispatch(showAlertSnackbar({type: "success", message: t('update_successfully')}));
            }
            setSelectedFile(null);
        })
        .catch((err) => {
            dispatch(showAlertSnackbar({type: "error", message: t('update_failed')}));
        })
    }

    useEffect(() => {
        setSelectedFile(null);
        setException(11007);
    }, [props.exceptionUpdate])
    useEffect(() => {
        if(exceptionListComplete) {
            if(exceptionListComplete.data) {
                if(exceptionListComplete.data.length > 0) {
                    let exceptionListCurr = [];
                    exceptionListComplete.data.map((exception) => {
                        if(exception.id === 11008 ||    // Not in service
                            exception.id === 11009 ||   // PO Box
                            exception.id === 11010) {   // Misrouting
                            exceptionListCurr.push(exception);
                        }
                    })
                    setExceptionList(exceptionListCurr);
                }
            }
        }
    }, [exceptionListComplete])

    return (
        <>
            <div
                style={{
                    display: 'flex',
                    alignItems: 'baseline'
                }}
            >
                {   exceptionList &&
                    <FixedTextField
                        fullWidth
                        select
                        label={t('exception_type')}
                        InputLabelProps={{ shrink: true }}
                        variant="outlined"
                        value={exception}
                        onChange={(e)=>{setException(e.target.value)}}
                        style={{minWidth: 410}}
                    >
                        {
                            exceptionList.length > 0 &&
                            exceptionList.map((exception) => (
                                <option key={exception.id} value={exception.id}>
                                    {exception.en_message}
                                </option>
                        ))}
                    </FixedTextField>
                }
                <FixedTextField
                    variant='outlined'
                    placeholder={t('input_parcel_no')}
                    onChange={handleOrderException}
                    onKeyPress={(e)=>handleKeyPress(e)}
                    value={orderException}
                    style={{maxWidth: 210, marginLeft: 10}}
                />
                <Button
                    variant="contained"
                    color="primary"
                    style={{ marginLeft: 10 }}
                    onClick={handleScanException}
                    onChange={handleOrderException}
                    onKeyPress={handleKeyPress}
                    disabled={!orderException}
                >
                    {t('update')}
                </Button>
                <input
                    color="primary"
                    type="file"
                    id="button-file-exception"
                    onChange={(e) => setSelectedFile(e.target.files[0])}
                    style={{display: 'none'}}
                />
                <label htmlFor="button-file-exception">
                    <Button
                        variant="contained"
                        style={{ marginLeft: 10 }}
                        color="primary"
                        component="span"
                        disabled={orderException}
                    >
                        {t('select_file')}
                    </Button>
                </label>
                <div style={{ marginLeft: 10 }} hidden={orderException}>
                    {selectedFile ? selectedFile.name : null}
                </div>
                <Button
                    variant="contained"
                    color="primary"
                    style={{ marginLeft: 10 }}
                    onClick={handleScanExceptionBatch}
                    onChange={handleOrderException}
                    onKeyPress={handleKeyPress}
                    disabled={orderException || (!orderException && !selectedFile) }
                >
                    {t('update_batch')}
                </Button>
            </div>
        </>
    );
}

export default ExceptionUpdate;